"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutopilotModeSchema = exports.ChangeKindSchema = exports.CHANGE_KIND_TIER = exports.TierSchema = void 0;
exports.tierOf = tierOf;
exports.canAutoApply = canAutoApply;
exports.canAutoPublish = canAutoPublish;
const zod_1 = require("zod");
/**
 * Automation Tier — PRS §9.
 * Quyết định một đề xuất được áp dụng thế nào. Đây là ranh giới an toàn của
 * toàn hệ thống, không phải cấu hình người dùng chỉnh được.
 */
exports.TierSchema = zod_1.z.enum(['A', 'B', 'C']);
/** Loại thay đổi mà Copilot có thể đề xuất, kèm Tier cố định của nó. */
exports.CHANGE_KIND_TIER = {
    metaTitle: 'A',
    metaDescription: 'A',
    canonical: 'A',
    robotsMeta: 'A',
    openGraph: 'A',
    twitterCard: 'A',
    altText: 'A',
    jsonLdSchema: 'A',
    sitemap: 'A',
    imageCompression: 'A',
    headingStructure: 'A',
    contactWidget: 'A',
    faq: 'B',
    cta: 'B',
    featureDescription: 'B',
    contentSection: 'B',
    blogOutline: 'B',
    // Bổ sung cho spec SC-02: mỗi mục kiểm tra sinh đề xuất phải có một `kind`,
    // và Tier của nó lấy Ở ĐÂY chứ không khai lại trong module đề xuất.
    // Giá trị phải khớp Tier khai trong `seo-checks.ts` — có test giữ điều đó.
    urlSlug: 'B',
    internalLinks: 'B',
    mobileViewport: 'B',
    performanceBudget: 'B',
    keywordCoverage: 'B',
    bilingualPair: 'B',
    langStorageKey: 'B',
    footerStandard: 'B',
    hubProductCount: 'B',
    pricing: 'C',
    commercialTerms: 'C',
    legalContent: 'C',
    customerNameOrLogo: 'C',
    capabilityClaim: 'C',
    performanceMetric: 'C',
};
exports.ChangeKindSchema = zod_1.z.enum(Object.keys(exports.CHANGE_KIND_TIER));
function tierOf(kind) {
    return exports.CHANGE_KIND_TIER[kind];
}
/** Chế độ Autopilot — PRS §11.2. */
exports.AutopilotModeSchema = zod_1.z.enum(['off', 'semi', 'full']);
/**
 * Tier C KHÔNG BAO GIỜ được tự áp dụng, ở mọi chế độ Autopilot — PRS §9.
 * Mọi nhánh code quyết định "có tự áp dụng không" phải đi qua hàm này.
 */
function canAutoApply(tier, mode) {
    if (tier === 'C')
        return false;
    if (tier === 'B')
        return false;
    return mode === 'semi' || mode === 'full';
}
/** Chỉ Tier A + Autopilot `full` mới được tự xuất bản — PRS §11.2. */
function canAutoPublish(tier, mode) {
    return tier === 'A' && mode === 'full';
}
//# sourceMappingURL=tier.js.map